module.exports = __webpack_public_path__ + "js/stellarium-web-engine.fd05ea5f.wasm";